<template>
  <div class="call-service" @click="callServiceAction">
    <img src="./images/icon_service.png" />
    <span>联系客服</span>
  </div>
</template>

<script>
export default {
  name: 'CallServiceButton',
  methods: {
    callServiceAction () {
      this.$emit('onCall')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.call-service {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 200px;
  height: 60px;
  background: #fafafa;
  border-radius: 40px;
  border: 1px solid #eeeeee;
  padding: 0 23px 0 28px;
  img {
    width: 29px;
    height: 29px;
  }
  span {
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 37px;
  }
}
</style>